<template>
  <div class="head">
    <div class="head-logo" @click="goHome">
      <div class="head-logo-img">
        <img
          src="@/assets/fwlogo.png"
          srcset="@/assets/fwlogo.png 1x, @/assets/fwlogo@2x.png 2x"
          alt=""
        />
      </div>
      <!-- <div>解放日报-新闻智能检索</div> -->
    </div>
    <div class="head-menu">
      <!-- <ul v-if="MenuStatus">
        <template v-for="(item, index) in arr">
          <router-link class="tab_item" :to="item.path" :key="index" tag="li">
            <span class="tab_span"
              ><i :class="item.icon"></i>{{ item.title }}</span
            >
          </router-link>
        </template>
      </ul> -->
    </div>

    <div class="head-user">
      <!-- <div style="margin-right: 40px" v-if="MenuStatus">
        <el-input
          placeholder="请输入关键字搜索"
          prefix-icon="el-icon-search"
          v-model="allKey"
          style="width: 200px"
          @keyup.enter.native="handleEnterSearch"
        >
        </el-input>
      </div> -->
      <router-link to="/">
        <div class="version">版本号 {{ version }}</div>
      </router-link>
      <div class="time">
        {{ today }}<span>{{ week }}</span>
      </div>
      <el-divider direction="vertical"></el-divider>

      <el-dropdown @command="fnUserCommand" size="large" trigger="click">
        <div class="user-name">
          <i class="avatar"></i>欢迎您：{{ userName }}
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item
            icon="el-icon-set-up"
            command="1"
            v-if="codes.indexOf('MIS2.0-background-manage') >= 0"
          >
            后台管理
          </el-dropdown-item> -->
          <!-- <el-dropdown-item icon="el-icon-switch-button" command="0">
            <a class="openOld" target="_blank" href="http://120.27.156.142:5990/">打开旧版</a>
          </el-dropdown-item> -->
          <el-dropdown-item icon="el-icon-switch-button" command="0">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { versionT } from "@/pages/views/version/version.js";
let moment = require("moment");
export default {
  computed: {
    ...mapGetters(["userName", "user", "codes", "isVisable"]),
  },
  props: {
    MenuStatus: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      version: "",
      arr: [],
      allKey: "",
      today: moment().format("YYYY-MM-DD"),
      week: "",
    };
  },

  activated() {},
  watch: {},
  created() {},
  mounted() {
    this.version = versionT;
    let week = moment().day();
    if (week == 0) {
      this.week = "周天";
    } else if (week == 1) {
      this.week = "周一";
    } else if (week == 2) {
      this.week = "周二";
    } else if (week == 3) {
      this.week = "周三";
    } else if (week == 4) {
      this.week = "周四";
    } else if (week == 5) {
      this.week = "周五";
    } else if (week == 6) {
      this.week = "周六";
    }
    // 通过事件总线监听消息
    // eventBus.$on("MenuStatus", (val) => {
    //   this.MenuStatus = val;
    // });
  },
  methods: {
    // 退出登录
    logout() {
      this.$confirm("确认退出登录？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    },

    goHome() {
      this.$router.go(0);
    },
    fnUserCommand(command) {
      if (command == 0) {
        this.logout();
      }
      // else if (command === 2) {
      //   this.$router.push("/noun");
      // } else {
      //   window.location.href = "/manage/";
      // }
    },

    handleEnterSearch() {
      const routeUrl = this.$router.resolve({
        path: "/searchResult",
        query: {
          allKey: this.allKey,
        },
      });
      window.open(routeUrl.href, "_blank");
      this.allKey = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  padding: 0 30px;
  position: sticky;
  background: #fff;
  top: 0;
  z-index: 2;
}
.head-logo {
  width: 273px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 22px;
  font-weight: 500;
  margin-right: 40px;
  cursor: pointer;
  .head-logo-img {
    width: 260px;
    height: 32px;
    img {
      height: 100%;
    }
  }
}
.head-menu {
  flex: 1;
  ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .tab_item {
      list-style: none;
      padding: 0 20px;
      font-size: 16px;
      font-weight: 500;
      color: var(--text-2);
      display: block;
      position: relative;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      .tab_span {
        display: block;
        i {
          margin-right: 4px;
        }
      }
      // &.router-link-active {
      // .tab_span {
      //   color: var(--brand);
      // }
      // }
      &.router-link-exact-active {
        .tab_span {
          color: var(--brand);
        }
        // &::after {
        //   content: " ";
        //   position: absolute;
        //   bottom: -20px;
        //   left: 0;
        //   display: block;
        //   width: 100%;
        //   height: 2px;
        //   background: var(--brand);
        // }
      }

      &:hover {
        color: var(--text-link);
      }
    }
  }
}

::v-deep .active {
  color: var(--brand) !important;
}

.head-user {
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .time {
    color: var(--text-2);
    span {
      margin-left: 5px;
    }
  }
  .version {
    margin-right: 20px;
    font-size: 12px;
    color: var(--text-tips);
    transition: color 0.2s ease-in-out;

    &:hover {
      color: var(--text-1);
    }
  }
}
.user-name {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--text-2);
  margin-left: 15px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: var(--text-1);
  }

  .avatar {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    display: block;
    background: url("~@/assets/default_avatar.png") no-repeat;
    background-size: 100%;
    margin-right: 5px;
  }
}
.el-icon-arrow-down {
  margin-left: 5px;
}
</style>
